module.exports = __webpack_public_path__ + "static/media/merriweather-v21-latin-regular.8276fdb7.woff2";